import Layout from '../../layout/index'

const agreementRouter = {
  path: '/agreement',
  component: Layout,
  redirect: '/agreement/index',
  children: [
    {
      path: 'index',
      name: 'agreement',
      component: () => import('../../views/agreement/index')
    }
  ]
}
export default agreementRouter
